import React, { useContext } from "react";
import AppContext from "../context/Context";
import ReserveFundRoutes from "../routes/ReserveFundRoutes";

const ReserveLayout = () => {
  const { isFluid } = useContext(AppContext);

  return (
    <div className={isFluid ? "container-fluid" : "container"}>
      <ReserveFundRoutes />
    </div>
  );
};

export default ReserveLayout;
